(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fz-samples-discovery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.fzs').forEach(root=>{
const thumbs=Array.from(root.querySelectorAll('[data-photo]'));
const stage=root.querySelector('.fzs-stage');
const mainImage=stage.querySelector('.fzs-hero');
const incomingImage=stage.querySelector('.fzs-hero-next');
const reduceMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let index=Math.max(0,thumbs.findIndex(b=>b.getAttribute('aria-pressed')==='true'));
let imageRequest=0;
let fadeTimer=null;

function finishFade(){
  if(fadeTimer){clearTimeout(fadeTimer);fadeTimer=null;}
  if(stage.classList.contains('fzs-is-fading') && incomingImage.getAttribute('src')){
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src=incomingImage.src;
    mainImage.alt=incomingImage.dataset.alt||'';
  }
  stage.classList.remove('fzs-is-fading');
  incomingImage.classList.add('fzs-fade-reset');
  incomingImage.removeAttribute('src');
  incomingImage.offsetWidth; // Reset without a reverse fade before another selection.
  incomingImage.classList.remove('fzs-fade-reset');
}

function transitionToPhoto(src, alt){
  if(!src) return;
  imageRequest++;
  const request=imageRequest;
  finishFade();
  if(mainImage.src===src){mainImage.alt=alt||'';return;}
  if(reduceMotion){
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src=src;
    mainImage.alt=alt||'';
    return;
  }
  const preloaded=new Image();
  preloaded.onload=()=>{
    if(request!==imageRequest) return;
    incomingImage.src=src;
    incomingImage.dataset.alt=alt||'';
    requestAnimationFrame(()=>{
      if(request!==imageRequest) return;
      requestAnimationFrame(()=>{
        if(request!==imageRequest) return;
        stage.classList.add('fzs-is-fading');
        fadeTimer=setTimeout(()=>{if(request===imageRequest) finishFade();},650);
      });
    });
  };
  preloaded.onerror=()=>{
    if(request!==imageRequest) return;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src=src;
    mainImage.alt=alt||'';
  };
  preloaded.src=src;
}

function show(i){
  if(!thumbs.length) return;
  index=(i+thumbs.length)%thumbs.length;
  const button=thumbs[index];
  transitionToPhoto(button.dataset.photo,button.dataset.alt||'');
  thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  button.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
}
thumbs.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
root.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>show(index+Number(button.dataset.direction))));
root.querySelector('.fzs-stage').addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1));}});

// Swipe on phones/tablets and drag with a mouse or stylus, without changing arrow behavior.
if(mainImage) mainImage.addEventListener('dragstart',event=>event.preventDefault());
let gestureStart=null;
const endGesture=()=>{
  gestureStart=null;
  stage.classList.remove('fzs-is-dragging');
};
stage.addEventListener('pointerdown',event=>{
  if(event.target.closest('button')) return; // Arrows continue to respond normally.
  if(event.pointerType==='mouse' && event.button!==0) return;
  if(gestureStart!==null) return;
  gestureStart={id:event.pointerId,x:event.clientX,y:event.clientY};
  if(stage.setPointerCapture) stage.setPointerCapture(event.pointerId);
  stage.classList.add('fzs-is-dragging');
});
stage.addEventListener('pointerup',event=>{
  if(!gestureStart || gestureStart.id!==event.pointerId) return;
  const deltaX=event.clientX-gestureStart.x;
  const deltaY=event.clientY-gestureStart.y;
  endGesture();
  if(Math.abs(deltaX)>=42 && Math.abs(deltaX)>Math.abs(deltaY)*1.2){
    show(index+(deltaX<0?1:-1));
  }
});
stage.addEventListener('pointercancel',endGesture);
stage.addEventListener('lostpointercapture',endGesture);



const purchaseForm=root.querySelector('form[action*="/cart/add"]');
if(purchaseForm && !purchaseForm.dataset.fzsAjax){
  purchaseForm.dataset.fzsAjax='true';
  const status=document.createElement('p');
  status.setAttribute('role','alert');
  status.hidden=true;
  purchaseForm.appendChild(status);
  let adding=false;
  purchaseForm.addEventListener('submit',async event=>{
    event.preventDefault();
    if(adding || !purchaseForm.reportValidity())return;
    const submit=purchaseForm.querySelector('button[type="submit"]');
    const notification=document.querySelector('cart-notification');
    const payload=new FormData(purchaseForm);
    payload.set('sections','cart-notification-product,cart-notification-button,cart-icon-bubble');
    payload.set('sections_url',location.pathname);
    adding=true;
    if(submit)submit.disabled=true;
    status.hidden=true;
    try{
      const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{
        method:'POST',headers:{Accept:'application/json'},body:payload
      });
      const data=await response.json();
      if(!response.ok || data.status>=400)throw new Error(data.description || data.message || window.cartStrings?.error || 'Unable to add item.');
      if(notification){
        notification.setActiveElement(submit);
        await notification.renderContents(data);
      }
    }catch(error){
      status.textContent=error.message;
      status.hidden=false;
    }finally{
      adding=false;
      if(submit)submit.disabled=false;
    }
  });
}

root.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',()=>{
  root.querySelector('[data-price]').textContent=input.dataset.price;
  root.querySelector('[data-compare]').textContent=input.dataset.compare;
  // Keep the visual gallery synchronized with the exact Shopify variant chosen by the customer.
  const photo=input.dataset.variantPhoto;
  if(photo){
    const thumbIndex=thumbs.findIndex(button=>button.dataset.photo===photo);
    if(thumbIndex!==-1){
      show(thumbIndex);
    }else{
      transitionToPhoto(photo,input.dataset.variantAlt||'');
      thumbs.forEach(button=>button.setAttribute('aria-pressed','false'));
    }
  }
  const url=new URL(location.href);
  url.searchParams.set('variant',input.value);
  history.replaceState({},'',url);
}));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
